import React from 'react';
import styles from './DownloadCar.module.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../../ui/Button/Button';

const DownloadCar = ({ car }) => {
  // 调试：检查车辆数�?

  // 安全的字段提取函数
  const getCarFieldValue = (field) => {
    if (field?.value !== undefined) {
      return field.value;
    }
    return typeof field === 'string' ? field : '';
  };

  // 检查数据结构，适应不同的数据格式
  const carData = car?.fields || car; // 支持嵌套在fields中或直接在顶层

  const title = getCarFieldValue(carData?.title);
  const text = getCarFieldValue(carData?.text);
  const buttons = carData?.buttons || [];

  // 检查图片数据结�?

  // 检查图片字段是否有有效数据
  const imageData = car?.fields?.image || carData?.image || car?.image;

  const hasValidImage =
    imageData?.fields &&
    (imageData.fields.desktopImage?.value?.src ||
      imageData.fields.tabletImage?.value?.src ||
      imageData.fields.mobileImage?.value?.src);

  // 获取桌面和移动端图片字段
  const desktopImageField = imageData?.fields?.desktopImage;
  const mobileImageField = imageData?.fields?.mobileImage || imageData?.fields?.tabletImage;

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        {hasValidImage && (
          <div className={styles.image}>
            <Image alt={title} field={desktopImageField} />
          </div>
        )}
        {hasValidImage && (
          <div className={styles.imageMobile}>
            <Image alt={title} field={mobileImageField} />
          </div>
        )}
        <div>
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
          <div className={styles.bottom}>
            <p className={styles.bottom_text}>Download:</p>
            <div className={styles.bottom_buttons}>
              {buttons.map((button, index) => {
                const buttonLabel =
                  getCarFieldValue(button?.fields?.label) || getCarFieldValue(button?.label);
                const buttonPath =
                  getCarFieldValue(button?.fields?.path) || getCarFieldValue(button?.path);
                const isComingSoon =
                  button?.fields?.isComingSoon?.value !== undefined
                    ? button?.fields?.isComingSoon?.value
                    : button?.isComingSoon || false;

                // 处理不同类型的链�?
                let href = '';
                if (typeof buttonPath === 'string') {
                  href = buttonPath;
                } else if (buttonPath?.href) {
                  href = buttonPath.href;
                }

                return (
                  <div key={button.id || index} className={styles.bottom_buttons_buttonWrapper}>
                    <Button
                      variant="secondary"
                      className={styles.bottom_buttons_buttonWrapper_button}
                      isShowTooltip={false}
                      target={href}
                    >
                      {buttonLabel}
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadCar;
